import styled from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 56px 40px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 560px) {
    padding: 32px 24px 28px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: ${props => props.theme.Cor_base_marca_01 || props.theme.brandColor1};
`;

export const Asterisks = styled.span`
  font-family: 'SourceSansPro', Arial, sans-serif;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 2px;
  line-height: 1;
  color: inherit;
`;

export const Title = styled.h2`
  font-family: 'SourceSansPro', Arial, sans-serif;
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 16px;
  width: 100%;
  text-align: center;
  color: ${props => props.theme.brandColor3 || '#4a4a4a'};
`;

export const Description = styled.p`
  font-family: 'SourceSansPro', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 24px;
  width: 100%;
  text-align: left;
  color: ${props => props.theme.brandColor3 || '#4a4a4a'};
`;

export const PhonesWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 16px;
`;

export const PhoneColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  flex: 1;
  min-width: 0;
`;

export const PhoneNumber = styled.span`
  font-family: 'SourceSansPro', Arial, sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: ${props => props.theme.alert};
  line-height: 1.2;
`;

export const PhoneLabel = styled.span`
  font-family: 'SourceSansPro', Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: ${props => props.theme.brandColor3 || '#4a4a4a'};
  margin-top: 4px;
  line-height: 1.3;
`;

export const SupportLink = styled.a`
  display: block;
  width: 100%;
  font-family: 'SourceSansPro', Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.alert};
  text-align: left;
  text-decoration: none;
  margin-bottom: 20px;

  &:hover {
    text-decoration: underline;
  }
`;

export const InfoBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid
    ${props => props.theme.Cor_base_marca_01 || props.theme.brandColor1};
  border-radius: 4px;
  background-color: ${props => props.theme.brandColor2 || '#fff'};
  padding: 12px 16px;
  margin-bottom: 24px;
`;

export const InfoText = styled.p`
  font-family: 'SourceSansPro', Arial, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0;
  text-align: center;
  white-space: nowrap;
  color: ${props => props.theme.brandColor3 || '#4a4a4a'};

  @media (max-width: 560px) {
    white-space: normal;
  }
`;

export const BackButton = styled.button`
  width: 100%;
  border: none;
  border-radius: 24px;
  background-color: ${props =>
    props.theme.Cor_base_marca_01 || props.theme.brandColor1};
  color: #fff;
  font-family: 'SourceSansPro', Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  padding: 12px 24px;
  cursor: pointer;
  outline: none;
  transition: opacity 200ms ease-in;

  &:hover {
    opacity: 0.9;
  }
`;
